import { useAuthQuery } from '@/lib/react-query-hooks'
import { authApi } from '@/features/auth/api'
import { useAuthStore } from '@/features/auth/store'
import type { UserInfoResponse } from '@/features/auth/types'
import { authKeys } from './queryKeys'

export function useCurrentUser() {
  const accessToken = useAuthStore(state => state.accessToken)

  return useAuthQuery<UserInfoResponse>({
    queryKey: authKeys.user(),
    queryFn: () => authApi.getCurrentUser(),
    enabled: Boolean(accessToken),
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
    refetchOnMount: false,
  })
}
